import {EvmHomeTotalTokenInfo} from '~/api/repository'
import {TOKEN_TYPE_NAME} from '~/constants/token.constants'
import {generalParamType} from '~/types/general.type'

export const HOME_REFETCH_PARAMS = [
  generalParamType.BLOCK,
  generalParamType.NORMAL_TRANSACTION_TOTAL_COUNT,
  generalParamType.INTERNAL_TRANSACTION_TOTAL_COUNT,
  // generalParamType.PENDING_TRANSACTION_TOTAL_COUNT,
  generalParamType.ACCOUNT,
  generalParamType.BALANCE,
]

export const HOME_CHART_TOOLTIP = {
  [generalParamType.BLOCK]: 'The average block time of the last hour.',
  BLOCK_NUMBER: 'The total number of blocks on the Henesys L1.',
  [generalParamType.NORMAL_TRANSACTION]: 'The average number of transactions over the last 3 days.',
  [generalParamType.NORMAL_TRANSACTION_TOTAL_COUNT]: 'The total number of transactions on the Henesys L1.',
  [generalParamType.DAILY_ACCOUNT]: 'The average number of accounts created over the last 3 days.',
  [generalParamType.ACCOUNT]: 'The total number of accounts created on the Henesys L1.',
  [generalParamType.GAS]: {
    gasPrice: 'The gas price of the latest transaction.',
    baseFee: 'The average block base fee of the last hour.',
    gasUsed: 'The average gas used per block over the last hour.',
  },
  [generalParamType.INTERNAL_TRANSACTION_TOTAL_COUNT]: 'The total number of internal transactions on the Henesys L1.',
  [generalParamType.CREATE_ACCOUNT]: 'The number of accounts created over the last 30 days.',
  [generalParamType.BURNT_FEE]: 'The amount of fees paid on blocks over the last 24 hours.',
  [generalParamType.TOKEN](tokenType: EvmHomeTotalTokenInfo.TKNTP): string {
    return `The total number of ${TOKEN_TYPE_NAME[tokenType]} token transfers on the Henesys L1.`
  },
  [generalParamType.BALANCE]: `Total supply is calculated by subtracting the amount used in NXPC Fission from the fixed max supply of 1 billion tokens.
  Tokens on BNB Smart Chain and Avalanche C-Chain are bridged representations of existing supply, not newly minted tokens.`,
  SUMMARY: {
    gasTracker: 'The gas price of the latest transaction.',
    dailyTransactions: 'The number of transactions over the last 24 hours.',
    averageBlockTime: 'The average block time of the last hour.'
  }
}